import merchantToken from "@/services/merchant.token";

const state = {
  errors: null,
  merchantToken: null
};

const getters = {
  merchantToken: (state) => state.merchantToken,
  errors: (state) => state.errors
};

const mutations = {
  setErrors(state, errors) {
    state.errors = errors;
  },
  setMerchantToken(state, payload) {
    state.merchantToken = payload
  }
};

const actions = {
  getMerchantToken: async ({ commit }, subdomain) => {
    try {
      const payload = {
        subdomain: subdomain
      };
      const token = await merchantToken.getMerchantToken(payload);

      commit("setMerchantToken", token);
    } catch (errors) {
      commit("setErrors", errors.errors);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
